// Final review quiz - shown after all 7 wonders.
// Selecting the correct option shows "Correct! 🎉"
// Selecting the wrong option shows "Oops, try again - pick another answer."

export const finalQuiz = [
  {
    id: "q1",
    question: "Which wonder is the longest wall ever built?",
    options: ["Petra", "Great Wall of China", "Colosseum", "Taj Mahal"],
    answer: 1,
  },
  {
    id: "q2",
    question: "Which wonder is a city carved into pink and red rocks?",
    options: ["Machu Picchu", "Chichen Itza", "Petra", "Colosseum"],
    answer: 2,
  },
  {
    id: "q3",
    question: "In which country can you find Machu Picchu?",
    options: ["Mexico", "Brazil", "Italy", "Peru"],
    answer: 3,
  },
  {
    id: "q4",
    question: "The Taj Mahal was built by Emperor Shah Jahan in memory of his…?",
    options: ["Wife", "Brother", "Father", "Friend"],
    answer: 0,
  },
];
